import * as React from 'react';
import { SVGProps } from 'react';

const IconPrinterStrokedSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 2v2H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h2v1a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-1h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1Zm2 1v1h6V3H5Zm7 8h1V6H3v5h1V9a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2Zm-6 2v-3h4v3H6Z"
    />
  </svg>
);
export default IconPrinterStrokedSizeS;
